import React from 'react'
import Image from 'next/image'
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight'
import AudioAction from '../audio/AudioAction'
import Container from '../foundations/Container'
import { MEDIA_POLICY_KEYS, resolveMediaPolicy } from '../primitives/mediaPolicy'
import styles from './LandingCategoriesV2.module.scss'

const categoryMediaPolicy = resolveMediaPolicy({ policy: MEDIA_POLICY_KEYS.CARD })

const LandingCategoriesV2 = ({
  categories,
  description,
  eyebrow,
  heading,
  loading,
  priority,
  title,
}) => (
  <section id='categories' className={styles.section} aria-labelledby='homepage-rental-categories-heading'>
    <Container width='wide' className={styles.container}>
      <div className={styles.sectionHeading}>
        {eyebrow && <span>{eyebrow}</span>}
        <h2 id='homepage-rental-categories-heading'>
          {heading || (title ? 'Explore our AV categories' : 'AV equipment rental categories')}
        </h2>
        {description && <p>{description}</p>}
      </div>

      <div className={styles.grid}>
        {categories.map((category, index) => (
          <article className={styles.card} key={category.cat}>
            <div className={styles.cardHeader}>
              <Image
                src={category.homepagePicture || category.picture}
                alt=''
                fill
                className={styles.backgroundImage}
                loading={priority && index < 3 ? undefined : loading}
                priority={priority && index < 3}
                quality={categoryMediaPolicy.quality}
                sizes={categoryMediaPolicy.sizes}
              />
              <div className={styles.headerShade} />

              <div className={styles.headerContent}>
                <div className={styles.icon}>
                  <Image
                    src={category.icon}
                    alt=''
                    width={96}
                    height={96}
                  />
                </div>

                <div className={styles.summary}>
                  <h3>{category.name}</h3>
                  <p>{category.sub}</p>
                </div>
              </div>
            </div>

            <div className={styles.cardBody}>
              <ul>
                {category.subCats.map((subCategory) => (
                  <li key={subCategory.name}>
                    <AudioAction
                      mode='text'
                      className={styles.categoryLink}
                      href={subCategory.link}
                    >
                      {subCategory.name}
                    </AudioAction>
                  </li>
                ))}
              </ul>

              <AudioAction
                mode='text'
                className={styles.viewAll}
                href={category.main}
                wrapContent={false}
              >
                View All {category.name} Rentals
                <FiArrowRight aria-hidden='true' />
              </AudioAction>
            </div>
          </article>
        ))}
      </div>
    </Container>
  </section>
)

export default LandingCategoriesV2
